import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Phone, Menu, X } from 'lucide-react';
import { companyInfo } from '../mock';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  const handleCall = () => {
    window.location.href = `tel:${companyInfo.phone}`;
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-white/95 backdrop-blur-md shadow-lg'
          : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          {/* Empty left space or brand text */}
          <div className="flex items-center">
            <div className={`text-xl font-bold transition-colors ${
              isScrolled ? 'text-slate-900' : 'text-white'
            }`}>
              STARK
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('home')}
              className={`font-medium transition-colors hover:text-slate-900 ${
                isScrolled ? 'text-slate-700' : 'text-white'
              }`}
            >
              Start
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className={`font-medium transition-colors hover:text-slate-900 ${
                isScrolled ? 'text-slate-700' : 'text-white'
              }`}
            >
              Leistungen
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className={`font-medium transition-colors hover:text-slate-900 ${
                isScrolled ? 'text-slate-700' : 'text-white'
              }`}
            >
              Über uns
            </button>
            <button
              onClick={() => scrollToSection('reviews')}
              className={`font-medium transition-colors hover:text-slate-900 ${
                isScrolled ? 'text-slate-700' : 'text-white'
              }`}
            >
              Bewertungen
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className={`font-medium transition-colors hover:text-slate-900 ${
                isScrolled ? 'text-slate-700' : 'text-white'
              }`}
            >
              Kontakt
            </button>
          </nav>

          {/* Desktop Call Button */}
          <Button
            onClick={handleCall}
            className="hidden lg:flex items-center space-x-2 bg-slate-900 hover:bg-slate-800 text-white"
          >
            <Phone className="w-4 h-4" />
            <span>{companyInfo.phone}</span>
          </Button>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`lg:hidden transition-colors ${
              isScrolled ? 'text-slate-900' : 'text-white'
            }`}
          >
            {isMobileMenuOpen ? (
              <X className="w-6 h-6" />
            ) : (
              <Menu className="w-6 h-6" />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <nav className="lg:hidden mt-4 pb-4 space-y-4">
            <button
              onClick={() => scrollToSection('home')}
              className={`block w-full text-left font-medium ${
                isScrolled ? 'text-slate-900' : 'text-white'
              }`}
            >
              Start
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className={`block w-full text-left font-medium ${
                isScrolled ? 'text-slate-900' : 'text-white'
              }`}
            >
              Leistungen
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className={`block w-full text-left font-medium ${
                isScrolled ? 'text-slate-900' : 'text-white'
              }`}
            >
              Über uns
            </button>
            <button
              onClick={() => scrollToSection('reviews')}
              className={`block w-full text-left font-medium ${
                isScrolled ? 'text-slate-900' : 'text-white'
              }`}
            >
              Bewertungen
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className={`block w-full text-left font-medium ${
                isScrolled ? 'text-slate-900' : 'text-white'
              }`}
            >
              Kontakt
            </button>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
